import useRouter from "common/hooks/use-router";
import { useCallback } from "react";
import CrudEdit from "common/components/Crud/CrudEdit";
import DocumentForm from "./DocumentForm";

function DocumentEdit() {
  const router = useRouter();

  const id = router.query.id as string;

  const back = useCallback(() => {
    router.navigate(`/documents/${id}`);
  }, [router, id]);

  return (
    <CrudEdit
      collectionName="documents"
      id={id}
      Form={DocumentForm}
      onBack={back}
    />
  );
}

export default DocumentEdit;
